export default __webpack_public_path__ + "static/media/cabinet1-before-768w.902d9a6d.png";